export const DEFAULT_RELEASE_LOG_URL = 'https://ycnz43zopd30.feishu.cn/wiki/OhuCwbSQuikwvykqjdPcKXcjn4c'

export const RELEASE_CATEGORIES = Object.freeze([
  { value: 'bugfix', label: '问题修复' },
  { value: 'feature', label: '新增功能' },
  { value: 'interaction', label: '交互升级' },
  { value: 'ui', label: '界面优化' },
  { value: 'performance', label: '性能提升' },
  { value: 'rules', label: '规则调整' },
])

export const RELEASE_ICONS = Object.freeze([
  { value: 'grid', label: '能力入口' },
  { value: 'sliders', label: '分析配置' },
  { value: 'database', label: '数据' },
  { value: 'settings', label: '设置' },
  { value: 'sparkles', label: '新能力' },
  { value: 'bug', label: '问题修复' },
  { value: 'rocket', label: '性能' },
  { value: 'shield', label: '规则' },
])

export function createEmptyRelease() {
  return {
    version: '', title: '', summary: '', releaseDate: '',
    items: [], highlightIds: [], fullLogUrl: DEFAULT_RELEASE_LOG_URL, sourceRefs: [],
  }
}

const length = value => Array.from(value || '').length
const isText = value => typeof value === 'string'
const categories = new Set(RELEASE_CATEGORIES.map(item => item.value))
const icons = new Set(RELEASE_ICONS.map(item => item.value))

export function isSafeReleaseUrl(value) {
  if (!isText(value) || !/^https:\/\//i.test(value) || /[\s\\]/.test(value)) return false
  try {
    const url = new URL(value)
    return url.protocol === 'https:' && Boolean(url.hostname) && !url.username && !url.password
  } catch { return false }
}

// 草稿可逐步补齐；发布时才要求完整内容。服务端仍是最终校验者。
export function validateReleaseContent(content, { publishing = false } = {}) {
  if (!content || typeof content !== 'object' || Array.isArray(content)) return ['公告内容必须是 JSON 对象']
  const errors = []
  const textField = (value, label, limit, required = false) => {
    if (value != null && !isText(value)) errors.push(`${label}必须是文本`)
    else if (required && !value?.trim()) errors.push(`请填写${label}`)
    else if (length(value) > limit) errors.push(`${label}不能超过 ${limit} 字`)
  }
  textField(content.version, '版本号', 32, true)
  if (isText(content.version) && !/^\d+\.\d+\.\d+(?:\.\d+)?(?:-[0-9A-Za-z.-]+)?$/.test(content.version.trim())) errors.push('版本号格式应为 3.0.1、3.0.2.1 或带预发布后缀的格式')
  textField(content.title, '更新标题', 20, publishing)
  textField(content.summary, '更新简介', 50, publishing)
  if (content.releaseDate) {
    if (!isText(content.releaseDate) || !/^\d{4}-\d{2}-\d{2}$/.test(content.releaseDate)
      || !Number.isFinite(Date.parse(`${content.releaseDate}T00:00:00Z`))
      || new Date(`${content.releaseDate}T00:00:00Z`).toISOString().slice(0, 10) !== content.releaseDate) errors.push('发布日期格式应为有效的 YYYY-MM-DD')
  } else if (publishing) errors.push('请填写发布日期')
  textField(content.fullLogUrl, '完整日志地址', 2000, publishing)
  if (content.fullLogUrl && !isSafeReleaseUrl(content.fullLogUrl)) errors.push('完整日志地址须为不含账号密码的有效 HTTPS 链接')

  const items = Array.isArray(content.items) ? content.items : []
  const highlights = Array.isArray(content.highlightIds) ? content.highlightIds : []
  if (!Array.isArray(content.items) || items.length > 100) errors.push('更新条目必须为数组且不超过 100 条')
  if (!Array.isArray(content.highlightIds)) errors.push('重点条目必须为 ID 数组')
  if (highlights.length > 4 || (publishing && highlights.length < 2)) errors.push('发布时需选择 2–4 项重点更新')
  if (new Set(highlights).size !== highlights.length) errors.push('重点条目不能重复')
  const ids = new Set()
  items.forEach((item, index) => {
    const label = `第 ${index + 1} 条更新`
    if (!item || typeof item !== 'object' || Array.isArray(item)) { errors.push(`${label}格式不正确`); return }
    if (!isText(item.id) || !/^[A-Za-z0-9_-]{1,64}$/.test(item.id)) errors.push(`${label}的 ID 须为 1–64 位字母、数字、下划线或连字符`)
    if (ids.has(item.id)) errors.push(`${label}的 ID 重复`)
    ids.add(item.id)
    if (!categories.has(item.category)) errors.push(`${label}须使用规定分类`)
    if (!icons.has(item.iconKey)) errors.push(`${label}须使用规定图标`)
    const highlighted = highlights.includes(item.id)
    textField(item.title, `${label}标题`, highlighted ? 10 : 100, publishing)
    textField(item.description, `${label}说明`, highlighted ? 45 : 2000, publishing)
  })
  highlights.forEach(id => { if (!isText(id) || !ids.has(id)) errors.push('重点条目必须引用已有更新条目') })
  if (content.sourceRefs != null && (!Array.isArray(content.sourceRefs) || content.sourceRefs.length > 100
    || content.sourceRefs.some(ref => !isText(ref) || length(ref) > 2000))) errors.push('内部来源须为不超过 100 项的文本数组，每项不超过 2000 字')
  return errors
}
